import { FormPassword, IDynamicFormRow } from '@src/components';
import { INPUT_CONFIG } from '@src/constants/inputConfig';
import { TFunction } from 'i18next';

type SetPasswordSchemaProps = {
    t: TFunction;
};
export function setPasswordSchema({
    t,
}: SetPasswordSchemaProps): IDynamicFormRow[] {
    return [
        {
            label: '',
            keyName: 'password',
            Component: FormPassword,
            inputProperties: {
                placeholder: 'Enter your new password',
                type: 'password',
                size: 'large',
            },
            formProps: {
                showStrengthMeter: true,
                minLength: INPUT_CONFIG.PASSWORD.minLength,
                maxLength: INPUT_CONFIG.PASSWORD.maxLength,
            },
            className: 'h-12',
            registerOptions: {
                required: { value: true, message: '' },
                minLength: {
                    value: INPUT_CONFIG.PASSWORD.minLength,
                    message: t('errors.formErrors.minLength', {
                        name: t('forms.password'),
                        length: INPUT_CONFIG.PASSWORD.minLength,
                    }),
                },
            },
        },
        {
            label: '',
            keyName: 'confirmPassword',
            inputProperties: {
                placeholder: 'Re-type your new password',
                type: 'password',
                size: 'large',
            },
            Component: FormPassword,
            className: 'h-12',
            registerOptions: {
                required: { value: true, message: '' },
                validate: (value: string, formValues: any) => {
                    return (
                        value === formValues.password ||
                        t('errors.passwordMismatch')
                    );
                },
            },
        },
    ];
}
